import React from "react";

const Page404:React.FC=()=>{
    return(
        <div><h1>Page Not found</h1></div>
    )
}

export default Page404;